/* eslint-disable  */
import React, { useEffect, useState } from 'react';
import { Container, Table, Header } from 'semantic-ui-react';
import { api } from '#/apis';
import Dimmer from '+/Dimmer';
import dayjs from 'dayjs';
import {min} from 'lodash'




const ViewAvailable = props => {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(false);


    useEffect(() => {
        setLoading(true);
        api.get('/availablePricing')
            .then(({ data }) => {
                // console.log(data.rows);
                setData(data.rows);
                setLoading(false);
            })
            .catch(err => {
                setErr(true);
            });
    }, []);

    if (err){
        return <Dimmer message='SOMETHING WENT WRONG, PLEASE RELOAD PAGE' />;
    }

    if (loading || !data) return <Dimmer message='Loading....This may take a while.'/>;


    return (
        <Container fluid className='overflow-x'>
            <Header content='All Available Units Pricing Report'/>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Property' />
                        <Table.HeaderCell content='UnitType' />
                        <Table.HeaderCell content='Unit' />
                        <Table.HeaderCell content='Available As of' />
                        <Table.HeaderCell content='Market price' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {(data || []).map((row, i) => (
                        <Table.Row key={i}>
                            <Table.Cell content={row.property_name} />
                            <Table.Cell content={row.unit_type} />
                            <Table.Cell content={row.unit_name} />
                            <Table.Cell content={row.available_as_of ? dayjs(row.available_as_of.split('T')[0]).format('MM-DD-YY'): "" } />
                            <Table.Cell content={row.market_price} />

                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

        </Container>
    );
};


export default ViewAvailable;
